import { gql } from 'graphql-request'
import { loginServiceGraphql } from '../config/Config';

export const resetPasswordGraphql = async (data) => {
  const RESET_PASSWORD = gql`
  mutation ResetPassword($phone: String!) {
    resetPassword(phone: $phone) {
      id
      fullname
      username
      phone
      email
    }
  }
  `
  const response = await loginServiceGraphql.request(RESET_PASSWORD, data);
  return response.resetPassword;
}